(function ($) {

    $(document).ready(function () {
      // Header scroll state (fast apply + smooth updates)
      (function () {
        var header = document.querySelector('.main-header');
        if (!header) return;

        function applyHeaderState() {
          var y = window.scrollY || document.documentElement.scrollTop || 0;
          header.classList.toggle('active', y >= 300);
        }

        applyHeaderState();

        var ticking = false;
        window.addEventListener('scroll', function () {
          if (!ticking) {
            requestAnimationFrame(function () { applyHeaderState(); ticking = false; });
            ticking = true;
          }
        }, { passive: true });

        window.addEventListener('load', applyHeaderState);
        window.addEventListener('pageshow', applyHeaderState);
      })();
      
      function initMobileMenu(){
        const $toggleControl = $('.menu-mobile-control');
        if (!$toggleControl.length) return;
        const $toggleBtn = $toggleControl.find('.menu-mobile-control__btn');
        if (!$toggleBtn.length) return;
        function toggleMobileMenu(){
          const isActive = !$toggleControl.hasClass('active');
          $toggleControl.toggleClass('active', isActive).attr('aria-expanded', String(isActive));
          $('.menu-mobile').toggleClass('active', isActive);
        }
        $toggleBtn.off('click.atsls').on('click.atsls', () => { toggleMobileMenu(); });
        $toggleControl.off('keydown.atsls').on('keydown.atsls', (e) => { if (e.which === 13 || e.which === 32) { e.preventDefault(); toggleMobileMenu(); } });
      }
      initMobileMenu();

  
        function addCaret() {
            if ($(window).width() <= 1200) {
                $('.menu-item-has-children > a').each(function() {
                    if ($(this).find('.thereCaret').length === 0) {
                        $(this).append('<span class="thereCaret"></span>');
                    }
                });
            } else {
                $('.menu-item-has-children .thereCaret').remove();
            }
        }

        function toggleSubMenu() {
            $(document).on('click', '.thereCaret', function(e) {
                e.preventDefault(); 
                let $parent = $(this).closest('.menu-item-has-children');
                let $subMenu = $parent.find('.sub-menu').first();
              
                $(this).toggleClass('active');
                $subMenu.toggleClass('openMenu');
            });
        }
    
        addCaret();
        toggleSubMenu();
    
        $(window).resize(function() {
            addCaret();
        });




        // FAQ
        $('.faq-title').on('click', function () {
            const faqItem = $(this).closest('.faq-item');
            const content = faqItem.find('.faq-content');
            const duration = 300;
  
            if (faqItem.hasClass('active')) {
                faqItem.removeClass('active');
                content.slideUp(duration);
            } else {
                faqItem.addClass('active');
                content.slideDown(duration);
            }
        });

        function applyHoverEffect() {
            if ($(window).width() >= 993) {
                $('.animation-cards .each-card').on('mouseenter', function () {
                    let card = $(this);
                    let hiddenText = card.find('.hidden-text');
                    let video = card.find('video');
        
                    hiddenText.css('height', hiddenText.prop('scrollHeight') + 'px');
                    card.find('.gb-inside-container figure').css('opacity', '1');
        
                    video.prop('muted', true).prop('playsinline', true).prop('loop', true)[0].play();
                });
        
                $('.animation-cards .each-card').on('mouseleave', function () {
                    let card = $(this);
                    let hiddenText = card.find('.hidden-text');
                    let video = card.find('video');
        
                    hiddenText.css('height', '0');
                    card.find('.gb-inside-container figure').css('opacity', '0');
        
                    video[0].pause();
                    video[0].currentTime = 0;
                });
            } else {
                $('.animation-cards .each-card').off('mouseenter mouseleave');
                $('.hidden-text').css('height', 'auto');
            }
        }
        
        applyHoverEffect();
        $(window).on('resize', applyHoverEffect);


        function isInViewport(element) {
            let elementTop = $(element).offset().top;
            let elementBottom = elementTop + $(element).outerHeight();
            let viewportTop = $(window).scrollTop() + 200;
            let viewportBottom = $(window).scrollTop() + $(window).height() - 200;
    
            return elementBottom > viewportTop && elementTop < viewportBottom;
        }
    
        function checkAndAnimateNumbers() {
            $('.number-counter').each(function () {
                if (isInViewport(this) && !$(this).hasClass('animated')) {
                    $(this).addClass('animated');
                    $(this).find('.anim-number').each(function () {
                        animateNumber($(this));
                    });
                }
            });
        }
    
        function animateNumber(element) {
            let number = element.data('value').toString().split(""); 
            element.empty();
    
            number.forEach((digit, index) => {
                let digitContainer = $('<span class="digit-con"></span>');
                let digitList = $('<span class="digit"></span>');
    
                for (let i = 0; i <= 9; i++) {
                    digitList.append(`<span>${i}</span>`);
                }
    
                digitContainer.append(digitList);
                element.append(digitContainer);
    
                let digitHeight = digitList.children().first().outerHeight();
                let offset = digit * digitHeight;
    
                setTimeout(() => {
                    digitList.css('transform', `translateY(-${offset}px)`);
                }, index * 200);
            });
        }
    
        $(window).on('scroll resize', checkAndAnimateNumbers);
        checkAndAnimateNumbers();

        $('.atsls-button.animated').each(function () {
          const $this = $(this);
          const content = $this.contents();
      
          if (!$this.children('span').length) {
              const $span = $('<span></span>');
              $this.empty().append($span).append(content);
          }
        });
    
    
        $('.scroll-cards .each-card').on('click', function (e) {
    
            let $targetLink;
    
            if ($(this).is('a')) {
                $targetLink = $(this);
            } else {
                $targetLink = $(this).find('.gb-container-link');
            }
    
            const href = $targetLink.attr('href');
    
            if (href && href.startsWith('#')) {
                const $scrollTarget = $(href);
    
                if ($scrollTarget.length) {
                    $('html, body').animate({
                        scrollTop: $scrollTarget.offset().top - 100
                    }, 500);
                }
            }
        });


        let $slider = $('.post-display-block--slider');
        $slider.slick({
            dots: false,
            arrows: true,
            infinite: true,
            // speed: 300,
            // autoplay: true,
            // autoplaySpeed: 8000,
            slidesToShow: 3,
            slidesToScroll: 1,
            prevArrow: '<button class="slick-prev"></button>',
            nextArrow: '<button class="slick-next"></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                  breakpoint: 768,
                  settings: {
                      slidesToShow: 1,
                  }
              }
            ]
        });

        (function initLeadershipSliders() {
          const sel = '.animation-cards-leadership, .leadership .leadership__list';

          function mount($list, w, count, $nav) {
            let settings = {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
              arrows: true,
              dots: true,
              appendArrows: $nav,
              appendDots: $nav,
              autoplay: true,
              autoplaySpeed: 5000,
            };

            if (w >= 1920 && w < 2400) {
              settings.slidesToShow = 5;
            } else if (w >= 2400) {
              settings.slidesToShow = 6;
            } else if (w < 992) {
              settings = {
                slidesToShow: w <= 540 ? 1 : 2,
                slidesToScroll: 1,
                infinite: true,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 5000,
              };
            }

            $list.slick(settings);
          }

          function update() {
            const w = $(window).width();
            $(sel).each(function () {
              const $list = $(this);
              const count = $list.children().length;
              const $section = $list.closest('.leadership');
              const $nav = $section.find('.slider-nav');

              if ($list.hasClass('slick-initialized')) {
                $list.slick('unslick');
              }

              mount($list, w, count, $nav);
            });
          }

          update();

          $(window).off('resize.leadership').on('resize.leadership', function () {
            clearTimeout(window.leadershipResizeTimer);
            window.leadershipResizeTimer = setTimeout(update, 300);
          });
        })();
        
        

        if ($('.equipment-animation').length) {
          const $parts = $('.equipment-animation .single-part');
          const $bgs = $('.equipment-animation .single-bg');
          const $logos = $('.equipment-animation [data-logo]');
          let currentIndex = 0;
          let isHovered = false;

          function activateSlide(index) {
            $parts.removeClass('hovered');
            $bgs.removeClass('hovered');
            $logos.css('opacity', '0.35');

            const $activePart = $parts.eq(index);
            const id = $activePart.data('id');
            $activePart.addClass('hovered');
            $('.equipment-animation .single-bg[data-bg="' + id + '"]').addClass('hovered');
            $('.equipment-animation [data-logo="' + id + '"]').css('opacity', '1');
          }

          activateSlide(currentIndex);

          $parts.on('mouseenter', function () {
            isHovered = true;
            const id = $(this).data('id');
            $parts.removeClass('hovered');
            $bgs.removeClass('hovered');
            $logos.css('opacity', '0.35');

            $(this).addClass('hovered');
            $('.equipment-animation .single-bg[data-bg="' + id + '"]').addClass('hovered');
            $('.equipment-animation [data-logo="' + id + '"]').css('opacity', '1');
          });

          $parts.on('mouseleave', function () {
            isHovered = false;
            activateSlide(currentIndex);
          });

          const slider = document.querySelector('.equipment-animation-svg');
          const totalScrollWidth = slider.scrollWidth;
          const viewportWidth = window.innerWidth;
          const scrollDistance = totalScrollWidth - viewportWidth;

          gsap.registerPlugin(ScrollTrigger);
          gsap.set(slider, { x: 0 });
          gsap.to(slider, {
            x: () => `-${scrollDistance}px`,
            ease: "none",
            scrollTrigger: {
              trigger: ".equipment-animation",
              pin: true,
              scrub: true,
              start: "top 10%",
              end: () => `+=${scrollDistance}`,
              onUpdate: self => {
                if (!isHovered) {
                  const progress = self.progress;
                  const total = $parts.length;
                  currentIndex = Math.min(Math.floor(progress * total), total - 1);
                  activateSlide(currentIndex);
                }
              }
            }
          });
          if (window.innerWidth <= 991) {
            slider.scrollLeft = -200;
          }
        }


//Interactive SVG Tabs
window.initInteractiveSvgTabsBlocks = function(){
  jQuery(function($){
    $('.interactive-svg-tabs').each(function(){
      const $block = $(this);
      if ($block.data('inited')) return;
      $block.data('inited', true);

      const $tabs = $block.find('.svg-tabs__nav-btn');
      const $panels = $block.find('.svg-tabs__panel');
      const $nav = $block.find('.svg-tabs__nav');
      const $underline = $nav.find('.svg-tabs__underline');
      const $carousel = $block.find('.svg-tabs__panels');
      const $tooltip = $block.find('.svg-dot-tooltip');

      let carouselInited = false;
      let accordionInited = false;

      const loadStageSvg = ($stage) => {
        if (!$stage || !$stage.length) return;
        const url = $stage.data('svg-url');
        if (!url || $stage.data('loaded')) return;
        $stage.data('loaded', true);
        $.get(url, function(markup){ if(!$stage.children().length){ $stage.html(markup); } }, 'text');
      };
      const unloadStageSvg = ($panel) => {
        const $stage = $panel.find('.svg-tabs__stage');
        if ($stage.length) { $stage.removeData('loaded').empty(); }
      };
      const ensureOnlyActive = (activeIdx) => {
        $panels.each(function(i){
          const $p = $(this);
          if (i === activeIdx) { loadStageSvg($p.find('.svg-tabs__stage')); }
          else { unloadStageSvg($p); }
        });
      };

      const updateUnderline = () => {
        const $active = $tabs.filter('.is-active');
        if (!$active.length || !$underline.length || !$nav.length) return;
        const navLeft = $nav.offset().left;
        const x = $active.offset().left - navLeft;
        const w = $active.outerWidth();
        $underline.css({ width: w, transform: 'translateX(' + x + 'px)' });
      };

      const applyMode = () => {
        const isMobile = window.innerWidth <= 991;
        if (isMobile) {
          if (carouselInited) { $carousel.slick('unslick'); carouselInited = false; }
          if (!accordionInited) {
            $block.addClass('is-accordion');
            $panels.each(function(){
              const $panel = $(this);
              const $btn = $panel.find('.svg-acc__btn');
              const $content = $panel.find('.svg-tabs__flex');
              $btn.attr('aria-expanded','false').removeClass('is-active');
              $content.hide();
            });
            const $first = $panels.eq(0);
            $first.find('.svg-acc__btn').attr('aria-expanded','true').addClass('is-active');
            $first.find('.svg-tabs__flex').show();
            ensureOnlyActive(0);
            $block.on('click.svgAcc','.svg-acc__btn, ._accBtn', function(){
              const $btn = $(this);
              const $panel = $btn.closest('.svg-tabs__panel');
              const isOpen = $btn.attr('aria-expanded') === 'true';
              $panels.each(function(){
                $(this).find('.svg-acc__btn').attr('aria-expanded','false').removeClass('is-active');
                $(this).find('.svg-tabs__flex').slideUp(200);
              });
              if (!isOpen) {
                $btn.attr('aria-expanded','true').addClass('is-active');
                $panel.find('.svg-tabs__flex').slideDown(200);
                const idx = $panels.index($panel);
                ensureOnlyActive(idx);
                $block.find('.svg-dot-tooltip.is-visible').removeClass('is-visible').attr('aria-hidden','true');
              }
            });
            accordionInited = true;
          }
        } else {
          if (accordionInited) { $block.removeClass('is-accordion'); $block.off('click.svgAcc'); $panels.find('.svg-tabs__flex').show(); accordionInited = false; }
          if (!carouselInited) {
            $carousel.slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              fade: true,
              arrows: false,
              dots: false,
              cssEase: 'linear',
              speed: 500,
              lazyLoad: 'progressive',
              swipe: true,
              draggable: true
            });
            carouselInited = true;
          }
        }
      };

      if ($tabs.length > 1) {
        $tabs.on('click', function(){
          const tabIndex = $(this).index();
          $tabs.removeClass('is-active').eq(tabIndex).addClass('is-active');

          $block.find('.svg-dot-tooltip.is-visible').removeClass('is-visible').attr('aria-hidden','true');

          if (carouselInited) { $carousel.slick('slickGoTo', tabIndex); }
          updateUnderline();
          ensureOnlyActive(tabIndex);
        });
        $tabs.removeClass('is-active').eq(0).addClass('is-active');
        updateUnderline();
        ensureOnlyActive(0);
      } else {
        $tabs.removeClass('is-active').eq(0).addClass('is-active');
        updateUnderline();
        ensureOnlyActive(0);
      }

      applyMode();

      $carousel.on('afterChange', function(e, slick, currentSlide){
        if ($tabs.length > 1) { $tabs.removeClass('is-active').eq(currentSlide).addClass('is-active'); }
        if ($tooltip.length) { $tooltip.removeClass('is-visible').attr('aria-hidden','true'); }
        updateUnderline();
        ensureOnlyActive(currentSlide);
      });

      const positionTooltip = ($dot) => {
        if (!$tooltip.length) return;
        let rectDot = $dot[0].getBoundingClientRect();
        if (!rectDot.width || !rectDot.height) {
          const child = $dot[0].querySelector && $dot[0].querySelector('rect,circle,ellipse,path,polygon,image');
          if (child) rectDot = child.getBoundingClientRect();
        }
        const rectBlock = $block[0].getBoundingClientRect();
        const pad = 10;
        const w = $tooltip.outerWidth();
        const h = $tooltip.outerHeight();
        let left = (rectDot.left - rectBlock.left) + (rectDot.width/2) - (w/2);
        let top  = (rectDot.top - rectBlock.top) - h - pad;
        const maxLeft = $block.innerWidth() - w - pad;
        if (left < pad) left = pad;
        if (left > maxLeft) left = maxLeft;
        if (top < pad) top = (rectDot.bottom - rectBlock.top) + pad;
        $tooltip.css({ left, top });
      };

      if (window.innerWidth > 992) {
        let $activeDot = null;
      
        $block.on('mouseenter', 'svg .dot', function () {
          const $dot = $(this);
          const $panel = $dot.closest('.svg-tabs__panel');
          const indexHotspot = Number($dot.data('index'));
          const $entry = $panel.find('.hotspots-data .hotspot[data-index="' + indexHotspot + '"]');
          const title = $entry.length ? $entry.find('h6').text().trim() : '';
          const text = $entry.length ? $entry.find('p').text().trim() : '';
      
          if ($tooltip.length) {
            $tooltip.empty();
      
            if (title) {
              const $h6 = $('<h6></h6>').text(title);
              $tooltip.append($h6);
            }
      
            if (text) {
              const $p = $('<p></p>').text(text);
              $tooltip.append($p);
            }
      
            if (title || text) {
              positionTooltip($dot);
              $tooltip.addClass('is-visible').attr('aria-hidden', 'false');
            } else {
              $tooltip.removeClass('is-visible').attr('aria-hidden', 'true').empty();
            }
          }
      
          $activeDot = $dot;
        });
      
        $block.on('mouseleave', 'svg .dot', function () {
          if ($tooltip.length) {
            $tooltip.removeClass('is-visible').attr('aria-hidden', 'true');
          }
        });
      
        if ($tooltip.length) {
          $tooltip.on('mouseleave', function () {
            $tooltip.removeClass('is-visible');
          });
        }
      
        $block.on('mousemove', 'svg .dot', function () {
          if ($activeDot && $activeDot[0] === this) {
            positionTooltip($activeDot);
          }
        });
      
      } else {
      
        $block.on('click touchend', 'svg .dot', function (e) {
          e.preventDefault();
          e.stopPropagation();
      
          const $dot = $(this);
          const $panel = $dot.closest('.svg-tabs__panel');
          const indexHotspot = Number($dot.data('index'));
          const $entry = $panel.find('.hotspots-data .hotspot[data-index="' + indexHotspot + '"]');
          const title = $entry.find('h6').text().trim();
          const text = $entry.find('p').text().trim();
      
          if ($tooltip.length) {
            $tooltip.empty();
      
            if (title) {
              const $h6 = $('<h6></h6>').text(title);
              $tooltip.append($h6);
            }
      
            if (text) {
              const $p = $('<p></p>').text(text);
              $tooltip.append($p);
            }
      
            if (title || text) {
              positionTooltip($dot);
              $tooltip.addClass('is-visible').attr('aria-hidden', 'false');
            } else {
              $tooltip.removeClass('is-visible').attr('aria-hidden', 'true').empty();
            }
          }
        });
      }


      $block.on('click', '[data-tooltip]', function(){
        if (window.innerWidth > 991) return;
        $(this).removeClass('is-visible').attr('aria-hidden','true');
      });

      $(window).on('resize.interactiveSvgTabs', function(){
        updateUnderline();
        applyMode();
        const idx = Math.max(0, $tabs.filter('.is-active').index());
        ensureOnlyActive(idx >= 0 ? idx : 0);
      });
    });
  });
};


jQuery(function(){ if (typeof window.initInteractiveSvgTabsBlocks === 'function') window.initInteractiveSvgTabsBlocks(); });


if ($('.past-events-slider').length && typeof $.fn.slick === 'function') {
  $('.past-events-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      adaptiveHeight: false
  });
}

function initSvgObserver(svgId, triggerId = 'start', threshold = 0.4) {
  const svg = document.getElementById(svgId);
  if (!svg) return;

  const start = svg.getElementById
    ? svg.getElementById(triggerId)
    : svg.querySelector(`#${triggerId}`);

  if (!start || !start.beginElement) return;

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          start.beginElement();
          observer.unobserve(svg);
        }
      });
    },
    { threshold }
  );

  observer.observe(svg);
}

initSvgObserver('logos-svg');

// end
    });

})(jQuery);